<template>
  <div class="container page" style="background: #1f1c1f;">
    <div class="header">
      <van-nav-bar :title="$t('q58')" class="nav-bar">
        <template #left>
          <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="topInfo">
            <span :class="statusClass(v.status)">{{ getStatusText(v.status) }}</span>
            <span>{{ amountLabel }}：+{{ v.money }}</span>
          </div>
          <div class="desc">
            <span>{{ networkLabel }}：{{ v.recharge_network || '--' }}</span>
          </div>
          <div class="desc">
            <span>{{ addressLabel }}：{{ v.recharge_address || '--' }}</span>
          </div>
          <div class="voucher" v-if="v.voucher_img">
            <span class="voucher-label">{{ voucherLabel }}：</span>
            <van-image class="voucher-image" :src="v.voucher_img" fit="cover" />
          </div>
          <div class="desc" v-else>
            <span>{{ voucherLabel }}：--</span>
          </div>
          <div class="desc">
            <span>{{ descLabel }}：{{ v.desc || '--' }}</span>
          </div>
          <div class="time">
            <span>{{ submitTimeLabel }}：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ checkTimeLabel }}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: []
    };
  },
  computed: {
    amountLabel() {
      return this.translateByLang({
        zh: "金额",
        en: "Amount",
        ja: "金額",
        kr: "금액"
      });
    },
    networkLabel() {
      return this.translateByLang({
        zh: "充值网络",
        en: "Network",
        ja: "入金ネットワーク",
        kr: "충전 네트워크"
      });
    },
    addressLabel() {
      return this.translateByLang({
        zh: "钱包地址",
        en: "Wallet Address",
        ja: "ウォレットアドレス",
        kr: "지갑 주소"
      });
    },
    voucherLabel() {
      return this.translateByLang({
        zh: "充值凭证",
        en: "Voucher",
        ja: "入金証明",
        kr: "충전 증빙"
      });
    },
    descLabel() {
      return this.translateByLang({
        zh: "说明",
        en: "Remark",
        ja: "備考",
        kr: "설명"
      });
    },
    submitTimeLabel() {
      return this.translateByLang({
        zh: "提交时间",
        en: "Submit Time",
        ja: "申請時間",
        kr: "제출 시간"
      });
    },
    checkTimeLabel() {
      return this.translateByLang({
        zh: "审核时间",
        en: "Review Time",
        ja: "審査時間",
        kr: "심사 시간"
      });
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    translateByLang(textMap) {
      const lang = localStorage.getItem("lang") || "en";
      return textMap[lang] || textMap.en;
    },
    getStatusText(status) {
      const statusMap = {
        1: this.translateByLang({
          zh: "审核中",
          en: "Pending",
          ja: "審査中",
          kr: "심사중"
        }),
        2: this.translateByLang({
          zh: "审核通过",
          en: "Approved",
          ja: "承認済み",
          kr: "승인됨"
        }),
        3: this.translateByLang({
          zh: "审核拒绝",
          en: "Rejected",
          ja: "拒否",
          kr: "거절됨"
        })
      };
      return statusMap[status] || this.translateByLang({
        zh: "未知",
        en: "Unknown",
        ja: "不明",
        kr: "알 수 없음"
      });
    },
    statusClass(status) {
      if (status === 2) {
        return "status success";
      }
      if (status === 3) {
        return "status reject";
      }
      return "status pending";
    },
    onRefresh() {
      this.getUserRechargeList(true);
    },
    getUserRechargeList(isRefresh = false) {
      this.$http({
        method: "get",
        url: "user_get_recharge_list"
      }).then((res) => {
        if (res.code === 200) {
          this.list = Array.isArray(res.data) ? res.data : [];
          if (isRefresh) {
            this.$toast(this.$t("reservation.refresh"));
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserRechargeList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main{
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}

.item_list{
  padding: 20px 20px;
  margin: 30px 10px;
  background: linear-gradient(120deg,#212121,#313131);
  border-radius: 14px;
  box-shadow: 0 2px 8px #000;
  line-height: 1.8;
  border: 1px solid #766350;
}

.topInfo{
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.topInfo span{
  font-size: 32px;
  font-weight: 700;
  color: #f3c7a2;
}

.status.success{
  color: #07c160;
}

.status.reject{
  color: #ee0a24;
}

.status.pending{
  color: #ffb020;
}

.desc span,
.time span,
.voucher-label{
  font-size: 25px;
  font-weight: 500;
  color: #f3c7a2;
  word-break: break-all;
}

.voucher{
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-top: 12px;
}

.voucher-image{
  width: 140px;
  height: 140px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #766350;
}
</style>
